import { useEffect, useState } from 'react';

// Abaixo de 768 px o painel vira "app": barra de topo com título, barra de
// navegação embaixo e menu em drawer. Vale igual no navegador do celular e no
// app nativo (Capacitor), que é o mesmo código rodando num WebView.
export const LARGURA_APP = 768;

function ehApp() {
  return typeof window !== 'undefined' && window.innerWidth < LARGURA_APP;
}

export function useAppShell() {
  const [app, setApp] = useState(ehApp);
  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${LARGURA_APP - 1}px)`);
    const mudou = () => setApp(ehApp());
    mql.addEventListener('change', mudou);
    return () => mql.removeEventListener('change', mudou);
  }, []);
  return app;
}
